<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">新增給付歸類說明</h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="receiver" class="col-2 text-right fontType">
                    <span class="text-red">＊</span>說明
                  </label>
                  <div class="col-4 d-flex flex-column">
                    <input
                      type="text"
                      maxlength="20"
                      name="categoryName"
                      placeholder="說明"
                      :class="{ 'is-invalid': isError }"
                      v-model="categoryName"
                      class="form-control"
                      @input="categoryName = categoryName.trim()"
                      @blur="categoryName = categoryName.trim()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="doCancel" class="btn btn-default editbtn mr-3">取消</a>
            <a @click="doInsert" class="btn btn-primary editbtn">新增</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { newCoverageCategoryMain } from "@/service";
export default {
  name: "InsuranceBenefitAddModal",
  mixins: [commonMixin],
  data() {
    return {
      categoryName: "",
      isError: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    categoryList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    doCancel() {
      this.$emit("cancel");
      this.$validator.reset();
      this.$toast.info({ title: "取消新增" });
    },
    doInsert() {
      //檢核
      this.isError = false;
      if (!this.categoryName) {
        this.$toast.info({ title: "請輸入說明" });
        this.isError = true;
        return;
      }
      this.categoryList.forEach((item) => {
        if (item.categoryName == this.categoryName) {
          this.isError = true;
          this.$toast.info({ title: "給付說明已存在" });
        }
      });
      if (this.isError) {
        return;
      }
      //通過檢查
      newCoverageCategoryMain(
        this.$store.state.userInfo.id,
        this.categoryName
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增成功" });
          this.$emit("close");
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    initData() {
      this.categoryName = "";
      this.isError = false;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}

.editbtn {
  width: 120px;
  height: 40px;
}

.getbtn {
  width: 180px;
  height: 40px;
  margin-bottom: -10px;
}

.editbtnFont {
  width: 100px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.fontType {
  font-family: PingFangTC;
}
</style>
